import { styled } from '@/styled-system/jsx';

export const ChatCopy = styled('div', {
  base: {
    color: 'hpxBlue600',
    paddingBottom: '5px',
  },
});
